import { Badge, FlexLayout } from '@deity/falcon-ui';
import { Icon } from '@deity-io/portal-ui';
import { countMappedRequiredFields, countSchemaFields } from 'components/Footer/MappingSummaryFooter/helpers';
import { CACHE_FIRST } from 'contracts/constants';
import _ from 'lodash';
import type { FC } from 'react';
import { useEffect, useMemo } from 'react';
import { useGetModelLazyQuery } from 'services/graphql/generated/hooks';
import styles from 'styling/badges.module.css';

const xxs: any = 'xxs';

type MappingStatusBadgeProps = {
  packageVersionUuid: string;
  schema: string;
};
export const MappingStatusBadge: FC<MappingStatusBadgeProps> = ({ packageVersionUuid, schema }) => {
  const [getTargetModel, { data: targetModelData }] = useGetModelLazyQuery(CACHE_FIRST);

  useEffect(() => {
    if (schema) {
      const targetUuid = _.get(schema, ['_meta', 'target']);

      if (targetUuid) {
        getTargetModel({
          variables: {
            packageVersionUuid,
            uuid: targetUuid
          }
        });
      }
    }
  }, [schema]);

  const targetRequired = useMemo(() => {
    if (targetModelData?.getModel.schema) {
      return countSchemaFields(targetModelData.getModel.schema).requiredFields;
    }
  }, [targetModelData?.getModel.schema]);

  const mappedRequired = useMemo(() => {
    if (schema && targetModelData?.getModel.schema) {
      return countMappedRequiredFields(schema, targetModelData?.getModel.schema);
    }
  }, [schema, targetModelData?.getModel.schema]);
  const missing = targetRequired! - mappedRequired!;

  return (
    <FlexLayout alignItems="center" width="full">
      {missing === 0 && (
        <Badge py={xxs} ml="xs" fontWeight="bold" className={styles.success}>
          <FlexLayout alignItems="center" mr="xs" fontSize="xxs">
            <Icon icon="check" sx={{ height: 18 }} />
          </FlexLayout>
          OK
        </Badge>
      )}

      {missing > 0 && (
        <Badge py={xxs} ml="xs" fontWeight="bold" className={styles.warning}>
          <Badge variant="round" style={{ lineHeight: 0 }} css={{ background: '#C39B3C', color: '#FFF3BD' }} mr="xs">
            {missing}
          </Badge>
          MISSING
        </Badge>
      )}
    </FlexLayout>
  );
};
